import { Moment } from 'moment'
import * as React from 'react'
import { connect } from 'react-redux'
import { Operation } from '../../domain/Operation'
import { TracepointRule } from '../../domain/TracepointRule'
import { ApplicationState } from '../../redux/ApplicationState'
import { getActiveTracepointRuleForTransaction } from '../../redux/V2/TracepointRule/TracepointRuleState'

export interface OwnProps {
    operation: Operation
}
export interface StateProps {
    tidewaysContext: any
    tracepoints: Array<TracepointRule<Moment>>
}
type Props = StateProps & OwnProps

class TracepointIndicator extends React.Component<Props> {
    public render() {
        if (this.props.tracepoints.length === 0) {
            return null
        }

        return this.props.tracepoints.map(tracepoint => {
            return (
                <span
                    className="burning"
                    key={tracepoint.id}
                    style={{ marginLeft: '0.5em' }}
                    title="tracepoint active for this transaction"
                >
                    <i className="fa fa-crosshairs" />
                </span>
            )
        })
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: Props) => {
    return {
        tidewaysContext: globalState.tidewaysContext,
        tracepoints: getActiveTracepointRuleForTransaction(globalState, props.operation),
    }
})(TracepointIndicator)
